





































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteConvitesStore from '@/components/Suporte/Store/SuporteConvitesStore'
import EventBus from '@/plugins/EventBus'
import { bytesToMegabytes } from '@/utils/common'
import _ from 'lodash'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteProcedimentosApenasHospitalDia extends Vue {
  loadingUpload: boolean = false
  fileUploadLimitInMegaBytes = 25
  allowedFileTypes: string[] = ['application/csv', 'application/x-csv', 'text/csv', 'application/vnd.ms-excel']

  get getSuporteConvitesStore() {
    return getModule(SuporteConvitesStore, this.$store)
  }

  get hospitalId() { return this.getSuporteConvitesStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteConvitesStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  formatDateLog(value: any) {
    if (['', null, undefined].includes(value)) return ' - '

    const options: any = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'America/Sao_Paulo',
    }

    return String(new Intl.DateTimeFormat('pt-BR', options).format(new Date(value))).replace(',', '')
  }

  async hospitalChange(id: any) {
    this.getSuporteConvitesStore.setHospitalId(id)
    this.getSuporteConvitesStore.clearCsv()
    this.getSuporteConvitesStore.clearLogs()
    this.loadingUpload = false
  }

  async inputFile(data: any) {
    this.getSuporteConvitesStore.clearLogs()
    const fileType: string = data.type
    if (!this.allowedFileTypes.includes(fileType)) return

    this.loadingUpload = true

    const fileSizeInMegabytes = bytesToMegabytes(data.file.size)

    if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar arquivo. Limite máximo excedido.', icon: 'warning', color: '#C62828' })
      this.loadingUpload = false
      return
    }

    if (data.identifier) {
      this.loadingUpload = false
      return
    }

    const form = new FormData()
    form.append('form', data.file)
    this.getSuporteConvitesStore.setCsv(form)
    const response = await this.getSuporteConvitesStore.importListaDeSecretariasCsv()
    this.getSuporteConvitesStore.clearCsv()

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao fazer o upload do arquivo ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingUpload = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Convites enviados com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'check',
      color: '#2E7D32',
    })

    this.loadingUpload = false
  }

  beforeDestroy() {
    this.getSuporteConvitesStore.clearHospitalId()
    this.getSuporteConvitesStore.clearCsv()
    this.getSuporteConvitesStore.clearLogs()
    this.loadingUpload = false
  }
}
